<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_cookie.jpeg')">
      <div class="content pos-relative legal-content">
        <go-to-top />
        <h1 class="main-title">
          Cookieポリシー
        </h1>
        <h2 class="update-time">
          最終更新日：2026年6月18日
        </h2>
        <p>
          本Cookieポリシーは、TIGER CASINOがウェブサイト、モバイルサイト、アプリ、関連サービスにおいてCookieおよび類似技術をどのように利用するかを説明するものです。
        </p>

        <h3 class="terms-title">
          1. Cookieとは
        </h3>
        <p>
          Cookieとは、お客様がウェブサイトへアクセスした際に、ブラウザや端末へ保存される小さなテキストファイルです。Cookieにより、サイトはお客様の端末やブラウザを認識し、ログイン状態の維持、表示設定の保存、セキュリティ確認、アクセス解析などを行うことができます。
        </p>

        <h3 class="terms-title">
          2. Cookieを使用する目的
        </h3>
        <p>
          TIGER CASINOは、以下の目的でCookieを使用します。
        </p>
        <ol class="terms-list">
          <li>サイトおよびアカウント機能を正常に動作させるため。</li>
          <li>ログイン状態、言語、表示設定、ブラウザ設定等を保持するため。</li>
          <li>サービス品質、表示速度、操作性を改善するため。</li>
          <li>お客様のサイト内行動を分析し、より関連性の高いコンテンツを表示するため。</li>
          <li>不正アクセス、複数アカウント、セキュリティリスクを検知・防止するため。</li>
          <li>アフィリエイト、紹介プログラム、キャンペーン効果を確認するため。</li>
          <li>チャットサポートその他のサポート機能を提供するため。</li>
        </ol>

        <h3 class="terms-title">
          3. 必要なCookie
        </h3>
        <p>
          必要なCookieは、TIGER CASINOの基本機能を提供するために不可欠なCookieです。これらは、ログイン、アカウント認証、決済画面、セキュリティ確認、ユーザー設定、コンテンツ表示等に使用されます。
        </p>
        <p>
          必要なCookieを無効にした場合、サイトが正常に動作しない、ログインできない、画面の一部が表示されない、決済またはゲーム機能が利用できない等の影響が生じる可能性があります。
        </p>

        <h3 class="terms-title">
          4. 収集される可能性のある情報
        </h3>
        <p>
          Cookieにより、以下の情報が収集される場合があります。
        </p>
        <ul class="terms-list">
          <li>アカウント識別情報およびログイン状態。</li>
          <li>ブラウザ、端末、OS、IPアドレス、アクセス日時等の技術情報。</li>
          <li>言語、表示、通知、セッション等の設定情報。</li>
          <li>サイト内の閲覧履歴、クリック、利用状況、参照元情報。</li>
          <li>アフィリエイトまたは紹介プログラムに関する識別情報。</li>
        </ul>

        <h3 class="terms-title">
          5. セッションCookieと永続Cookie
        </h3>
        <p>
          TIGER CASINOは、セッションCookieおよび永続Cookieを使用する場合があります。
        </p>
        <ul class="terms-list">
          <li>セッションCookie：ブラウザを閉じる、またはログアウトすることで失効する一時的なCookieです。</li>
          <li>永続Cookie：一定期間ブラウザまたは端末に保存され、再訪問時の設定保持や認識に使用されます。保存期間は、Cookieの種類や利用目的により異なります。</li>
        </ul>

        <h3 class="terms-title">
          6. Cookieの管理方法
        </h3>
        <p>
          お客様は、ご利用のブラウザ設定からCookieの保存、削除、ブロック、通知設定を変更できます。設定方法はブラウザにより異なります。主なブラウザのヘルプをご確認ください。
        </p>
        <ul class="terms-list">
          <li>Google Chrome</li>
          <li>Safari</li>
          <li>Firefox</li>
          <li>Microsoft Edge / Internet Explorer</li>
        </ul>
        <p>
          スマートフォンをご利用の場合は、端末またはブラウザの設定画面でCookie、サイトデータ、トラッキング設定を確認してください。Cookieの削除または制限に関する一般情報は、www.aboutcookies.org でも確認できます。
        </p>

        <h3 class="terms-title">
          7. 注意事項
        </h3>
        <p>
          Cookieを無効化または削除した場合、TIGER CASINOの一部機能が利用できない、表示が正しく行われない、ログイン状態が維持されない、セキュリティ確認が正常に完了しない等の影響が生じる場合があります。
        </p>
        <p>
          本ポリシーは、サービス内容、利用技術、法令、規制、外部サービスの変更に応じて更新されることがあります。重要な変更がある場合は、サイト上で告知します。
        </p>
      </div>
    <!-- content End -->
    </div>
  <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'CookiePolicyTiger',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
/* 段落標題：與上一段拉開距離、貼近自己的內容 */
.terms-title {
  margin-top: 2.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
}

/* 段落間距 */
.content p {
  margin: 0 0 1rem;
}

/* 項目清單：黑底上的項目符號改為白色 */
.terms-list {
  margin: 0.5rem 0 1rem 1.5rem;
}

ul.terms-list,
ol.terms-list {
  list-style-position: outside;
  padding-left: 1.4rem;
}

ul.terms-list {
  list-style: disc;
}

ol.terms-list {
  list-style: decimal;
}

.terms-list li {
  margin-bottom: 0.35rem;
}

.terms-list li::marker {
  color: #fff;
}
</style>
